<template>
  <div class="contenido">
    <v-card class="elevation-6" style="opacity:0.8;">
      <v-card-text>
        <v-layout row wrap class="my-2">
          <v-tooltip color="primary" top>
            <template v-slot:activator='{ on }'>
              <v-icon v-on='on' color="primary" x-large @click="$root.$emit('onOpcionPortal', 'principal')">keyboard_backspace</v-icon>
            </template>
            <span>Ir atrás</span>
          </v-tooltip>
          <v-spacer/>
          <span class="primary--text">
            <h3><v-icon class="my-1" color="primary">library_books</v-icon>&nbsp;Base Legal</h3>
          </span>
          <v-spacer/>
        </v-layout>
        <v-layout wrap>
          <v-flex sm12 md12>
              <div class="decretosBoton">
                  <v-menu bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" small tile outline color="primary">
                  <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
                  </v-btn>
              </template>
              <v-card class="px-2">
                <v-card-text class="black--text body-2">
                    <h4><v-icon class="my-1" small color="info">info</v-icon>&nbsp;Usted puede dar lectura a las partes más relevantes de las normas legales vigentes en el País que sustentan la Declaración de Jurada de Bienes y Rentas</h4>
                </v-card-text>
              </v-card>
            </v-menu>
                </div>
          <span class="decretos">
            <v-icon class="my-1" small color="info">info</v-icon>&nbsp;Usted puede dar lectura a las partes más relevantes de las normas legales vigentes en el País que sustentan la Declaración de Jurada de Bienes y Rentas<br><br>
          </span>
          </v-flex>
        </v-layout>
        <v-card class="elevation-4 scroll">
          <v-expansion-panel>
            <v-expansion-panel-content>
              <template v-slot:header>
                <span class="primary--text subheading text-uppercase">Artículo 233</span>
              </template>
              <v-container class="pt-0">
                <span class="font-weight-bold">Artículo 233 de la Constitución Política del Estado</span><br>
                <div style="text-align: justify;"><span>'...Son servidoras y servidores públicos las personas que desempeñan funciones públicas. Las servidoras y servidores públicos pertenecen a la carrera administrativa, excepto aquellas personas que desempeñen cargos electivos, las designadas y los designados, y quienes ejerzan funciones de libre nombramiento...'.</span></div>
              </v-container>
            </v-expansion-panel-content>
            <v-expansion-panel-content>
              <template v-slot:header>
                <span class="primary--text subheading text-uppercase">Artículo 235</span>
              </template>
              <v-container class="pt-0">
                <span class="font-weight-bold">Artículo 235 de la Constitución Política del Estado</span><br>
                <div style="text-align: justify;"><span>'...Son obligaciones de las servidoras y los servidores públicos: ... 3) Prestar Declaración Jurada de Bienes y Rentas antes, durante y después del ejercicio del cargo...'.</span></div>
              </v-container>
            </v-expansion-panel-content>
            <v-expansion-panel-content>
              <template v-slot:header>
                <span class="primary--text subheading text-uppercase">Artículo 54</span>
              </template>
              <v-container class="pt-0">
                <span class="font-weight-bold">Artículo 54 de la Ley 2027 del Estatuto del Funcionario Público</span><br>
                <div style="text-align: justify;"><span>'Las Declaraciones Juradas de Bienes y Rentas deberán observar los principios de universalidad, obligatoriedad, periodicidad y transparencia. Las Declaraciones Juradas de Bienes y Rentas de los funcionarios públicos electos, designados, de libre nombramiento y aquellos de carrera especialmente determinados conforme a Reglamento, estarán además sometidos al principio de publicidad, pudiendo incluso el Órgano Rector Gubernamental, a efectos de verificación, solicitarles nuevas declaraciones juradas sobre sus bienes y rentas hasta un año después de haber determinado su vinculación con la Administración.'</span></div>
              </v-container>
            </v-expansion-panel-content>
            <v-expansion-panel-content>
              <template v-slot:header>
                <span class="primary--text subheading text-uppercase">Artículo 53</span>
              </template>
              <v-container class="pt-0">
                <span class="font-weight-bold">Artículo 53 de la Ley 2027 del Estatuto del Funcionario Público</span><br>
                <div style="text-align: justify;"><span>'Todos los servidores públicos, cualesquiera sea su condición, jerarquía, calidad o categoría están obligados a prestar declaraciones expresa sobre los bienes y rentas que tuvieren al momento de iniciar su relación laboral con la administración. Durante la vigencia de la relación laboral del servidor con la administración y aún al final de la misma, cualquiera sea la causa de terminación, las declaraciones de bienes y rentas de éstos, podrán ser, en cualquier momento, objeto de verificación. Al efecto, los servidores públicos, prestarán declaraciones periódicas conforme a reglamentación expresa.'</span></div>
              </v-container>
            </v-expansion-panel-content>
            <v-expansion-panel-content>
              <template v-slot:header>
                <span class="primary--text subheading text-uppercase">Artículo 33</span>
              </template>
              <v-container class="pt-0">
                <span class="font-weight-bold">Artículo 33 de la Ley 004 Ley de Lucha contra la Corrupción, Enriquecimiento Ilícito e Investigación de Fortunas</span><br>
                <div style="text-align: justify;"><span>'...(Falsedad en la Declaración Jurada de Bienes y Rentas). El que falseare u omitiere insertar los datos económicos, financieros o patrimoniales, que la Declaración Jurada de Bienes y Rentas debá contener, incurrirá en privación de libertad de uno a cuatro años y multa de cincuenta a doscientos días...'</span></div>
              </v-container>
            </v-expansion-panel-content>
            <v-expansion-panel-content>
              <template v-slot:header>
                <span class="primary--text subheading text-uppercase">Artículo 149</span>
              </template>
              <v-container class="pt-0">
                <span class="font-weight-bold">Artículo 149 del Código Penal (Modificado por la ley 004)</span><br>
                <div style="text-align: justify;"><span>'La servidora o el servidor público que conforme a la Ley estuviere obligado a declarar sus bienes y rentas a tiempo de tomar posesión o a tiempo de dejar su cargo y no lo hiciere, será sancionado con multa de treinta días. '</span></div>
              </v-container>
            </v-expansion-panel-content>
            <v-expansion-panel-content>
              <template v-slot:header>
                <span class="primary--text subheading text-uppercase">Decreto Supremo Nº 2528</span>
              </template>
              <v-container class="pt-0">
                <span class="font-weight-bold">Decreto Supremo Nº 2528, 23 de septiembre de 2015</span><br>
                <v-btn :loading="loadingButton" color='primary' @click='descargarArchivoPdf(1)' loader = 'loadingButton'><v-icon>get_app</v-icon>&nbsp;Descargar PDF</v-btn>
              </v-container>
            </v-expansion-panel-content>
            <v-expansion-panel-content>
              <template v-slot:header>
                <span class="primary--text subheading text-uppercase">DECRETO SUPREMO N° 1233</span>
              </template>
              <v-card>
                <v-container class="pt-0">
                  <span class="font-weight-bold">DECRETO SUPREMO N° 1233 EVO MORALES AYMA PRESIDENTE CONSTITUCIONAL DEL ESTADO PLURINACIONAL DE BOLIVIA</span><br>
                  <v-btn :loading="loadingButton" color='primary' @click='descargarArchivoPdf(2)' loader = 'loadingButton'><v-icon>get_app</v-icon>&nbsp;Descargar PDF</v-btn>
                </v-container>
              </v-card>
            </v-expansion-panel-content>
            <v-expansion-panel-content>
              <template v-slot:header>
                <span class="primary--text subheading text-uppercase">Procedimiento para el Llenado de DJBR</span>
              </template>
              <v-container class="pt-0">
                <span class="font-weight-bold">Procedimiento para el Llenado, Presentación, Recepción y Verificación de la Declaración Jurada de Bienes y Rentas - <i>Publicado en fecha 24/03/2022</i></span><br>
                <v-btn :loading="loadingButton" color='primary' @click='descargarArchivoPdf(3)' loader = 'loadingButton'><v-icon>get_app</v-icon>&nbsp;Descargar PDF</v-btn>                      
              </v-container>
            </v-expansion-panel-content>
            <v-expansion-panel-content>
              <template v-slot:header>
                <span class="primary--text subheading text-uppercase">Reglamento de Control de DJBR</span>
              </template>
              <v-container class="pt-0">
                <span class="font-weight-bold">Reglamento de Control de la Declaración Jurada de Bienes y Rentas en las Entidades y Empresas Públicas - <i>Publicado en fecha 07/04/2022</i></span><br>
                <v-btn :loading="loadingButton" color='primary' @click='descargarArchivoPdf(4)' loader = 'loadingButton'><v-icon>get_app</v-icon>&nbsp;Descargar PDF</v-btn>                      
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-card>
        <br><br><br><br><br><br>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import PdfView from '@/common/util/PdfView.vue';
import Normas from './mixins/normas.js';
export default {
  components: {
    PdfView
  },
  mixins: [
    Normas
  ],
  data: () => ({
    repetidosModal: false,
    codigo: '',
    archivo: '',
    loadingButton: false
  }),
  methods: {
    async descargarArchivoPdf (dato) {
      let urlArchivo = '';
      let usuario = 'portal';
      let nombreUsuario = 'usuario_portal';
      switch (dato) {
        case 1: urlArchivo = 'archivo_predefinido/decreto_supremo_2528';
          break;
        case 2: urlArchivo = 'archivo_predefinido/decreto_supremo_1233';
          break;
        case 3: urlArchivo = 'archivo_predefinido/procedimiento_de_presentacion_djbr';
          break;
        case 4: urlArchivo = 'archivo_predefinido/reglamento_de_control';
          break;
      }
      this.loadingButton = true;
      this.$service.get(`${urlArchivo}/${usuario}/${nombreUsuario}`).then(response => {
        this.downloadPDF(response.documento, response.nombre);
        this.loadingButton = false;
      }).catch(e => {
        console.log(e);
        this.loadingButton = false;
        this.$message['warning']('No se pudo descargar el archivo, vuelva a intentarlo');
      });
    },
    downloadPDF (pdf, name) {
      const url = window.URL.createObjectURL(
        this.b64toBlob(pdf, 'application/pdf')
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${name}.pdf`);
      document.body.appendChild(link);
      link.click();
    },
    b64toBlob (b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      let byteCharacters = atob(b64Data);
      let byteArrays = [];

      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);

        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        let byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      let blob = new Blob(byteArrays, { type: contentType });
      return blob;
    }
  }
};
</script>
<style scoped>
.bt-enlace {
  border: none;
  color: red;
  display: inline-block;
  font-size: 16px;
}
.btx {
  background: transparent !important;
}
.subtitulo {
  color: #1976d2;
  text-transform: uppercase;
}
.texto-justicado {
  text-align: justify;
  font-size: 14px;
}
.padding-label {
  padding-top: 15px;
  padding-bottom: 15px;
}
.contenido {
  padding-right: 10%;
  padding-top: 2%;
  padding-left: 10%;
}
.scroll {
  overflow-y: scroll;
}
</style>


// WEBPACK FOOTER //
// src/components/portal/baseLegal.vue